<template>
  <div
    ref="container"
    :tabindex="isOpen ? 0 : -1"
    @keyup.esc="$emit('update:is-open', false)"
  >
    <v-navigation-drawer
      :model-value="isOpen"
      app
      temporary
      location="right"
      color="primary"
      dark
      @update:model-value="$emit('update:is-open', $event)"
    >
      <v-list nav density="compact" class="primary" dark>
        <template
          v-for="(item, index) in (items || []).filter(item => !isEmpty(item))"
          :key="index"
        >
          <v-divider v-if="item.divider" class="my-4" color="white" />
          <v-list-item
            v-else
            v-set-test-id="[
              'BaseSideMenu',
              item.testId || item.to || item.href,
            ]"
            :to="item.to"
            :href="item.href"
            exact
            :target="
              item.href && isExternalLink(item.href) ? '_blank' : undefined
            "
            @click="item.onPressed && item.onPressed()"
          >
            <template v-if="item.icon" #prepend>
              <v-list-item-media class="mr-3">
                <font-awesome-icon :icon="item.icon" class="mr-4" />
              </v-list-item-media>
            </template>
            <v-list-item-title>
              {{ item.label }}
              <font-awesome-icon
                v-if="item.href"
                :icon="faExternalLink"
                class="ml-1"
              />
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script lang="ts" setup>
import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { ref, watch } from 'vue';
import type { ZvdZLocationRaw } from '@/plugins/router';
import isExternalLink from '@/common/is-external-link';
import type { ActionableComponentProps } from '@/common/components/ActionableComponent';
import { vSetTestId } from '@/common/components/ActionableComponent';
import { isEmpty } from 'underscore';

export type MenuItem = {
  icon?: IconDefinition;
  label?: string;
  to?: ZvdZLocationRaw;
  href?: string;
  onPressed?: () => void;
  divider?: boolean;
  testId?: string;
};

type Props = ActionableComponentProps & {
  isOpen?: boolean;
  items?: MenuItem[];
};
const props = defineProps<Props>();
type Emits = { (e: 'update:is-open', v: boolean): void };
defineEmits<Emits>();

const container = ref();
watch(
  () => props.isOpen,
  isOpen => {
    if (!isOpen) {
      return;
    }
    if (!container.value) {
      throw new Error('No container found in BaseSideMenu.');
    }
    container.value.focus();
  },
);
</script>
